import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
    init() {
        // JavaScript to be fired on the home page

        //Homepage gsap animations

        //Animate featured funds carousel
        const fundsCarousel = document.querySelector('.funds-carousel');

        gsap.fromTo(fundsCarousel, 
        {
            x: 500,
            autoAlpha: 0,
        },
        {
            x: 0,
            autoAlpha: 1,
            duration: 1,
            ease: 'power2.easeOut',
            scrollTrigger: fundsCarousel, 
        });


        //Fund filter controls
        const $filterLabelRow = $('.filter-label-row');
        const $filterLabels = $filterLabelRow.find('.filter-label');

        $filterLabels.on("click", function() {
            // Remove selected class from all labels and add to this one
            $filterLabels.removeClass('selected');
            $(this).addClass('selected');

            // Target the filter box that corresponds to this label
            const dataFilterRow = $(this).data('filter-row');
            const filterRow = $(`.fund-filters .filters-row${dataFilterRow}`);
            
            // Hide all filter boxes and show the corresponding one
            $('.fund-filters .filters-row').removeClass('selected');
            filterRow.addClass('selected');



            //Apply animation to all child filter options
            let fundFilter = document.querySelectorAll('.fund-filters .selected');
            let filterOptions = fundFilter[1].children;

            filterOptions = gsap.utils.toArray(filterOptions);

            const tl = gsap.timeline();
            const tween = gsap.fromTo(filterOptions,
            {
              autoAlpha: 0,
            },
            {
              autoAlpha: 1,
              duration: 1,
              stagger: 0.2,
              ease: 'power2.easeOut',
            });

            tl.add(tween);

            //Restart filter animation on selecting a new option
            tl.restart();
            tl.play();
        });
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateTemplateHome2022.js